import  { useState, useEffect } from "react";
import "./ModulesAdmin.css";
import Select from "react-select";
import firebaseHelper from "../../../helpers/firebaseHelper";

function ModuleModal({
  module,
  onClose,
  onSave,
  onDelete,
  isSaving,
  userRole,
}) {
  const [pageName, setPageName] = useState(module.pageName);
  const [pageURL, setPageURL] = useState(module.pageURL);
  const [status, setStatus] = useState(module.isActive ? "active" : "inactive");
  const [icon, setIcon] = useState(module.pageIconUrl);
  const [priority, setPriority] = useState(module.priority);
  const [description, setDescription] = useState(module.description);
  const [isVisibleForAll, setIsVisibleForAll] = useState(
    module.isVisibleForAll,
  );
  const [subsidiaries, setSubsidiaries] = useState([]);
  const [selectedSubsidiaries, setSelectedSubsidiaries] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [iconUploadError, setIconUploadError] = useState(null)

  useEffect(() => {
    const fetchSubsidiariesList = async () => {
      const subsidiariesList = await firebaseHelper.fetchSubsidiaries()
      setSubsidiaries(subsidiariesList)

      if (module.subsidiaries && module.subsidiaries.length > 0) {
        const selected = subsidiariesList.filter(sub => 
          module.subsidiaries.includes(sub.value)
        );
        setSelectedSubsidiaries(selected);
      }
    };
    fetchSubsidiariesList();
  }, []);

  // Função de upload de arquivo
  const handleIconUpload = async (file) => {

    try {
      setIsUploading(true);
      setIconUploadError(null);
      const fileURL = await firebaseHelper.uploadModuleIcon(file)

      setIcon(fileURL);
    } catch (error) {
      setIconUploadError(error.message)
      console.warn("[handleIconUpload] Erro no upload do icon: ", error);
    } finally {
      setIsUploading(false); 
    }
  };

  const handleSave = () => {
    onSave({
      ...module,
      pageName,
      pageURL,
      isActive: status === "active",
      icon, // Salva a URL do ícone
      priority,
      description,
      isVisibleForAll,
      subsidiaries: selectedSubsidiaries.map((option) => option.value),
    });
  };

  const handleSubsidiaryChange = (selectedOptions) => {
    setSelectedSubsidiaries(selectedOptions);
  };

  return (
    <div className="modal">
      <div className="modal-content-modules">
        <h2>Edit Module</h2>
        <label>
          <p>Name:</p>
          <input
            className="input-modules"
            type="text"
            value={pageName}
            onChange={(e) => setPageName(e.target.value)}
          />
        </label>
        <label>
          <p>Description:</p>
          <input
            className="input-modules"
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>
        <label>
          <p>Link:</p>
          <input
            className="input-modules"
            type="text"
            value={pageURL}
            onChange={(e) => setPageURL(e.target.value)}
          />
        </label>
<label>
  <p>Icon:</p>
  <input
    className="input-modules"
    type="file"
    accept="image/*"
    onChange={(e) => handleIconUpload(e.target.files[0])}
    disabled={isUploading}
  />
</label>
{iconUploadError && (

  <p style={{
    color: 'red',
    fontSize: '0.9em',
    margin: '4px auto 8px auto',
    padding: '0',
    textAlign: "center"
  }}>
    {iconUploadError}
  </p>
)} 
{isUploading && (
  <p style={{
    color: 'blue',
    fontSize: '0.9em',
    margin: '4px auto 8px auto',
    padding: '0',
    textAlign: "center"
  }}>
    Uploading...
  </p>
)}
        <label>
          <p>Order Priority:</p>
          <input
            className="input-modules"
            type="number"
            value={priority}
            min="1"
            max="20"
            onChange={(e) => setPriority(e.target.value)}
          />
        </label>
        <label>
          <p>Status:</p>
          <select
            className="status-dropdown"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </label>
        {userRole === "admin_global" && (
          <>
            <label>
              <p>Subsidiaries:</p>
              <Select
                isMulti
                options={subsidiaries}
                value={selectedSubsidiaries}
                onChange={handleSubsidiaryChange}
                className="subsidiary-select-dropdown"
                placeholder="Choose subsidiaries..."
              />
            </label>
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isVisibleForAll}
                onChange={(e) => setIsVisibleForAll(e.target.checked)}
              />
              <span>Visible for all users</span>
            </label>
          </>
        )}
        <div className="modal-actions-modules">
          <button onClick={onClose}>Cancel</button>
          {userRole === "admin_global" && (
            <button
              className="deleteModuleButton"
              onClick={() => onDelete(module)}
            >
              Delete Module
            </button>
          )}
          <button onClick={handleSave} disabled={isUploading}>
            Save
          </button>
        </div>
        {isSaving && (
          <div className="loading-overlay">
            <div className="spinner"></div>
            <p>Saving changes, please wait...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ModuleModal;
